<div
  #header
  tabindex="0"
  class="composable-collapse-header"
  (keydown)="handleKeyboardEvent($event)"
  (click)="onHeaderClick($event)"
>
  <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>

  <ftr-icon
    class="composable-collapse-header__icon"
    [icon]="isOpen ? 'KeyboardArrowUp' : 'KeyboardArrowDown'"
  ></ftr-icon>
</div>

@if (isOpen) {
  <div>
    <div [@accordionWithOverflowFixAnimation]="isOpen ? 'showing' : 'hidden'">
      <ng-container *ngTemplateOutlet="bodyTemplate"></ng-container>
    </div>
  </div>
}
